import { RulerUpdateDetails } from "../maplayers/ruler-layer";

export enum NearestPortEvents {
    Ruler = 'ruler',
    PortHighlightChange = 'port-highlight-change',
    DropPin = 'drop-pin',
}

export interface NearestPortPosition {
    name?: string;
    position?: number[]|number[][];
}

export interface NearestPortHighlights extends NearestPortPosition {
    ports: NearestPortPosition[];
}

export abstract class NearestPortModelBase extends EventTarget
{
    abstract updateRuler(detail: RulerUpdateDetails): void;
    abstract setPortHighLight(detail: NearestPortHighlights): void;
    abstract setDropPin(detail: NearestPortPosition): void;
}

let NearestPortModel: NearestPortModelBase|null = null;

function setNearestPortModel(model: NearestPortModelBase)
{
    NearestPortModel = model;
}

export { NearestPortModel, setNearestPortModel };
